export default __webpack_public_path__ + "static/media/Selena_9781408312858.c23edf9c.jpg";